import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/functions'
import ImageKit from 'imagekit-javascript'
import firebaseConfig from './firebase.config.json'
import imagekitConfig from './imagekit.config.json'

export const app = firebase.initializeApp(firebaseConfig)
export const db = app.firestore()
export const storageRef = app.storage().ref()
export const imagekit = new ImageKit({
    publicKey: imagekitConfig.publicKey,
    urlEndpoint: imagekitConfig.urlEndpoint,
})
